import { Fragment } from "react";
import type { Subscription } from "api";
import type { LoadStatus } from "hooks/useProfile";
import type { GotoTarget } from "./dashboard.model";
import { usageMeters } from "./dashboard.model";
import { DashboardCard } from "./DashboardCard";

type UsageCardProps = {
  subscriptions: Subscription[];
  status: LoadStatus;
  onGoto: (target: GotoTarget) => void;
};

/**
 * One bar per subscription, fullest first. There is no plan behind these — the
 * account is a set of per-tool allowances, and that is what the card shows.
 */
export const UsageCard = ({ subscriptions, status, onGoto }: UsageCardProps) => {
  const meters = usageMeters(subscriptions);

  return (
    <DashboardCard
      title="Monthly usage"
      sub={`${meters.length} ${meters.length === 1 ? "subscription" : "subscriptions"} · resets on the 1st`}
      status={status}
      isEmpty={meters.length === 0}
      empty="Nothing is subscribed yet."
      failure="Could not load your usage. Please refresh the page."
    >
      {/* Rows and bars are siblings, not pairs in a wrapper: the design spaces
          them off one another with `.dsh__meter-r:not(:first-child)`. */}
      <div className="dsh__meter">
        {meters.map((meter) => (
          <Fragment key={meter.key}>
            <div className="dsh__meter-r">
              <span>{meter.label}</span>
              <b>{meter.text}</b>
            </div>
            {/* An unlimited tool has nothing to fill, so it gets no bar. */}
            {meter.limit !== null && (
              <div className="dsh__bar">
                <i style={{ width: `${meter.percent}%` }} />
              </div>
            )}
          </Fragment>
        ))}
      </div>

      <div className="dsh__plan-a">
        <button type="button" className="pcbtn" onClick={() => onGoto({ pane: "myqubics" })}>
          Manage subscriptions
        </button>
      </div>
    </DashboardCard>
  );
};
